// initialValues.js
const panchangInitialValues = {
  start_time: "",
  end_time: "",
  day: "",
  samvat: "",
};
export default panchangInitialValues;